export default __webpack_public_path__ + "static/media/hoverImg1.ce92fac9.svg";